import { getMediaDimensions } from 'utils/helpers'
import { computeAspectRatio, validatePlacementForSlot } from '../../../../media'

const getMediaKind = (file) => {
  const type = file?.type ?? file?.file?.type

  if (type?.startsWith('image/')) {
    return 'image'
  }

  if (type?.startsWith('video/')) {
    return 'video'
  }

  return null
}

export const validateGroupMediaType = (file, { groupImages, originalMedia, fileToReplaceId }, t) => {
  const newFileKind = getMediaKind(file)

  if (!newFileKind) {
    return t('common.errors.fileFormat')
  }

  let groupFiles = groupImages ?? []

  if (fileToReplaceId) {
    groupFiles = groupFiles.filter((item) => item.id !== fileToReplaceId)
  }

  const groupMembers = originalMedia ? [...groupFiles, originalMedia] : [...groupFiles]

  const hasImages = groupMembers.some((item) => getMediaKind(item) === 'image')
  const hasVideos = groupMembers.some((item) => getMediaKind(item) === 'video')

  if (hasImages && hasVideos) {
    return t('Recommendations.campaign.setup.media.errors.formatMismatch', { fileName: file.name })
  }

  if (newFileKind === 'video' && hasImages) {
    return t('Recommendations.campaign.setup.media.errors.formatMismatch', { fileName: file.name })
  }

  if (newFileKind === 'image' && hasVideos) {
    return t('Recommendations.campaign.setup.media.errors.formatMismatch', { fileName: file.name })
  }

  return null
}

const validateFileForRatio = async (file, requiredRatio, t) => {
  if (!file.type?.startsWith('image/') && !file.type?.startsWith('video/')) {
    return t('common.errors.fileFormat')
  }

  try {
    const dimensions = await getMediaDimensions(file)

    if (!dimensions?.width || !dimensions?.height) {
      return t('common.errors.fileFormat')
    }

    const ratio = computeAspectRatio(dimensions.width, dimensions.height)

    if (!validatePlacementForSlot(dimensions.width, dimensions.height, requiredRatio)) {
      return t('Recommendations.campaign.setup.media.errors.image.ratioSlot', {
        fileName: file.name,
        requiredRatio,
        uploadedRatio: ratio,
      })
    }

    return null
  } catch {
    return t('common.errors.fileFormat')
  }
}

export const handleMediaGroupSlotFileSelect = async (
  file,
  {
    groupId,
    ratio,
    isReplace,
    fileToReplaceId,
    groupImages,
    originalMedia,
    originalId,
    onAddToSlot,
    onReplaceInSlot,
    t,
  },
) => {
  if (!file) {
    return { error: null }
  }

  if (!file.path) {
    file.path = file.name
  }

  const formatError = validateGroupMediaType(
    file,
    { groupImages, originalMedia, fileToReplaceId: isReplace ? fileToReplaceId : null },
    t,
  )

  if (formatError) {
    return { error: formatError }
  }

  const ratioError = await validateFileForRatio(file, ratio, t)

  if (ratioError) {
    return { error: ratioError }
  }

  try {
    if (isReplace && fileToReplaceId) {
      await onReplaceInSlot?.(file, fileToReplaceId, ratio)
    } else {
      await onAddToSlot?.(file, groupId, ratio, originalId)
    }

    return { error: null }
  } catch (error) {
    return { error: error?.message || t('common.genericError') }
  }
}
